import type { StepBadgeProps } from "./step-badge.type";

import { CheckOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import classNames from "classnames";

import "./step-badge.style.less";

export const StepBadge = ({ step, status }: StepBadgeProps) => {
  return (
    <div className={classNames("step-badge", { [`-${status}`]: status })}>
      <Typography>
        {status === "finished" ? <CheckOutlined /> : step}
      </Typography>
    </div>
  );
};
